export const blurText = 'blur-md select-none'
export const blurTextWithMargin = 'blur-md select-none mx-px-24 '
